import React from "react";

// Import images
import clintTrust from "../../Assets/img/clinttrust.svg";
import feature1 from "../../Assets/img/clint-3.svg";
import feature2 from "../../Assets/img/Group 43166.svg";
import feature3 from "../../Assets/img/Group 43162.svg";
import feature4 from "../../Assets/img/clint-4.svg";

const ClientsTrustSection = () => {
  return (
    <section className="container Apply-padding">
      <section className="row align-items-center ">
        {/* Left: Image with layered borders */}
        <div className="col-md-5 d-flex justify-content-center">
          <div className="image-container">
            <div className="image-wrapper">
              <img src={clintTrust} alt="Clients Trust" className="w-100"/>
              <span className="image-layer-1"></span>
              <span className="image-layer-2"></span>
            </div>
          </div>
        </div>

        {/* Right: Content */}
        <div className="col-md-7">
          <h2 className="section-title-1 mt-3 md:mt-0">Why Clients Trust Us</h2>
          <p className="mb-4 text-md-start">
            At AnaxiTech, we go beyond filling roles — we build long-term talent partnerships
            that drive business growth. Our recruitment approach is tailored, transparent, and
            performance-driven, helping organizations of all sizes find the right talent at the
            right time.
          </p>

          <div className="feature-grid">
            {/* Feature 1 */}
            <div className="feature-box">
              <div className="feature-icon">
                <img src={feature1} alt="Industry-Focused Hiring Icon" />
              </div>
              <div className="feature-text">Industry-Focused Hiring</div>
            </div>

            {/* Feature 2 */}
            <div className="feature-box">
              <div className="feature-icon">
                <img src={feature2} alt="Global Talent Network Icon" />
              </div>
              <div className="feature-text">Global Talent Network</div>
            </div>

            {/* Feature 3 */}
            <div className="feature-box">
              <div className="feature-icon">
                <img src={feature3} alt="Full-Cycle Recruitment Icon" />
              </div>
              <div className="feature-text">Full-Cycle Recruitment</div>
            </div>

            {/* Feature 4 */}
            <div className="feature-box">
              <div className="feature-icon">
                <img src={feature4} alt="Accelerated Results Icon" />
              </div>
              <div className="feature-text">Accelerated Results</div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default ClientsTrustSection;
